module.exports = __webpack_public_path__ + "static/img/153608_3_4.9bf14e4a.jpg";